module.exports = __webpack_public_path__ + "static/media/limitedTimeOffers.ab8babd9.svg";